"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var calNewIndex = function (operation) { return function (indexes) {
    var indexNow = indexes.indexNow, lastIndex = indexes.lastIndex;
    if (operation === '+') {
        return indexNow + 1 > lastIndex ?
            0 : indexNow + 1;
    }
    else {
        return indexNow - 1 < 0 ?
            lastIndex : indexNow - 1;
    }
}; };
exports.default = calNewIndex;
